import { render, staticRenderFns } from "./group-page.vue?vue&type=template&id=40ded307"
import script from "./group-page.vue?vue&type=script&lang=js"
export * from "./group-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports